import { render, staticRenderFns } from "./CampusSelection.vue?vue&type=template&id=36651a54&scoped=true&"
import script from "./CampusSelection.vue?vue&type=script&lang=ts&"
export * from "./CampusSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CampusSelection.vue?vue&type=style&index=0&id=36651a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36651a54",
  null
  
)

export default component.exports